// Copyright (c) 2016 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIM_ATTACHMENT_CLAIM_TYPES);




// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/get-claim-types.js